import React from "react";
import { Link, useParams } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";
import blogs from "./data/blogs";
import AppSubscribe from "./global/AppSubscribe";
import SocialLinks from "./global/SocialLinks";

const Blog = () => {
  const { slug } = useParams();

  const blog = blogs.find(
    (blog) => blog.title.toLowerCase().split(" ").join("-") === slug,
  );

  return blog ? (
    <MainLayout>
      <div className="container grid lg:grid-cols-2 items-center gap-8 mb-14">
        <div>
          <span className="h-0.5 w-1/2 mx-auto lg:mx-0 lg:w-[220px] rounded-full bg-crimson-ffs block mb-1" />
          <h1 className="text-center lg:text-left pr-2">{blog.title}</h1>
          <span className="hidden lg:block">{blog.date}</span>
        </div>
        <div
          className="bg-cover bg-no-repeat h-[179px] md:h-[344px] rounded-br-[30px]"
          style={{
            backgroundImage: `url("${require(`../assets/img/blogs/${slug}.png`)}")`,
          }}
        />
      </div>
      <section className="container mb-24 md:mb-36">
        <div className="">
          <div className="lg:grid lg:grid-cols-4 lg:gap-8 lg:relative xl:max-w-full xl:mx-auto xl:gap-16">
            {blog.body.map((section, sectionIndex) => (
              <div key={sectionIndex} className="grid gap-8 col-span-5 xl:pr-8">
                <h4 className="font-bold">
                  {sectionIndex + 1}. {section.heading}:
                </h4>
                <div className="flex flex-col gap-4 mb-8">
                  {section.description.map((paragraph, paragraphIndex) => (
                    <p
                      className={`${paragraph.startsWith("-") ? "pl-8" : ""}`}
                      key={paragraphIndex}
                    >
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
            <div className="grid gap-8 col-span-5 xl:pr-8">
              <p>
                If you're looking for tailored financial solutions and expert
                guidance to support your organization's mission, we invite you
                to explore our range of services from financial planning to
                grant writing assistance, we're here to help you thrive at{" "}
                <Link
                  to="/contact"
                  className="font-bold text-crimson-ffs hover:text-poly-cyan with-transition"
                >
                  Forager Financial Services
                </Link>
                .
              </p>
            </div>
            <div className="grid md:hidden place-items-center mt-8 mb-24 md:mb-36">
              <span className="w-full flex md:block h-0.5 rounded-full bg-denim-ffs opacity-20 mb-8" />
              <SocialLinks isDenim />
            </div>
          </div>
        </div>
        <span className="hidden md:flex h-0.5 rounded-full bg-denim-ffs opacity-20 mt-14" />
        <div className="hidden md:flex justify-center mt-8 mb-24 md:mb-36">
          <SocialLinks isDenim />
        </div>
        <div className="xl:w-[80%] mx-auto flex flex-col lg:flex-row gap-8 mb-24 items-center justify-between mt-[50px]">
          <div className="w-[100%] lg:w-fit">
            <h3 className="text-crimson-ffs mb-1">Cashflow Compass</h3>
            <span className="text-navy-blue-ffs">
              By Forager Financial Services
            </span>
            <p className="mt-8 mb-4">
              “The tools you need to financial prosperity with practical
              insights and expert guidance.”
            </p>
            <p>
              You will get an email with 2 financial tips and 1 question for you
              to ponder bi-weekly. If you are looking for tailored financial
              solutions for your organization’s mission enter your email and
              sign up for free right now.
            </p>
          </div>
          <div className="w-full xl:w-[500px] h-[400px] md:h-[340px] -order-1 lg:order-2">
            <AppSubscribe />
          </div>
        </div>
      </section>
    </MainLayout>
  ) : (
    <></>
  );
};

export default Blog;
